import React from 'react';
import {withRouter} from "react-router";

const routerWrapper = (WrappedComponent) => {
  return withRouter(
    class RouterWrapper extends React.Component {
      render() {
        return <WrappedComponent {...this.props}/>
      }
    }
  );
};

export default routerWrapper;
